import React, { Component } from "react";
import { Pie, Bar } from "react-chartjs-2";

import { connect } from "react-redux";
import { openModal } from "../../../../store/actions/ModalActions";
import { package_chart_data } from "../../../../constants/chart_definitions";

import {
  GetPackageOverallV4,
  GetPackageClusterV4,
  GetPackageAreaV4,
} from "../../../../store/actions/reports-v4/package_service_actions";
import PieChartLoader from "../../../../components/extensions/PieChartLoader";

import { IconButton, Toolbar } from "@material-ui/core";
import { AspectRatio, Search } from "@material-ui/icons";
import PackageViewFilter from "../../view_filters/Packages/PackageViewFilter";
import NoChartData from "../../../../components/extensions/ErrorPageDefaults/NoChartData";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { DashboardContext } from "../../dashboard_context";
import moment from "moment";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import { SetChartPackagesTitle } from "../../../../store/actions/reports/chart_title_actions";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

const package_filter = {
  from: fromDate,
  to: toDate,
};

class PackageView extends Component {
  state = {
    dataSet: {
      items: [],
      labels: [],
      colors: [],
    },
    isLoading: false,

    chartData: null,
    dates: package_filter,
    toView: "piece",
    clusterId: null,
    areaId: null,
    areaSelectContext: null,
    clusterSelectContext: null,
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.premiseGetPackageOverallV4({
      dates: this.state.dates,
      isRange: false,
    }).then((resp) => {
      this.refresh();
      this.setState({ isLoading: false });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.package_list !== this.props.package_list) {
      this.refresh();
    }
  }

  refresh = () => {
    var data = this.appendChartData();
    var items = package_chart_data(data);
    this.setState({ chartData: items });
  };

  appendChartData = () => {
    let { package_list } = this.props;
    let temppackage_list = [];
    if (package_list) {
      temppackage_list = package_list;
    }
    let data = temppackage_list.map((item) => {
      return {
        name: item.packageName,
        value:
          this.state.toView === "piece"
            ? item.totalPieces
            : item.totalPrincipal,
      };
    });
    var tempDataset = {
      ...this.state.dataSet,
      items: data.map((item) => item.value),
      labels: data.map((item) => item.name),
    };
    return tempDataset;
  };

  renderPie = () => {
    return this.state.isLoading === true ? (
      "Loading..."
    ) : (
      <div>
        <Bar
          options={{
            title: {
              display: false,
              text: this.props.chartTitle,
              fontsize: 20,
            },
            layout: {
              padding: {
                left: 60,
                right: 60,
                top: 40,
                bottom: 20,
              },
            },
            legend: {
              display: false,
              position: "left",
            },
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (tooltipItem) {
                    let dataset = tooltipItem.dataset;
                    let currentValue = dataset.data[tooltipItem.dataIndex];
                    let total = dataset.data.reduce((a, b) => a + b, 0);
                    let percentage = ((currentValue / total) * 100).toFixed(2);
                    return ` ${percentage}%`;
                  },
                },
              },
              datalabels: {
                display: true,
                color: "#212121",
                formatter: function (value, context) {
                  let dataset = context.dataset.data;
                  let total = dataset.reduce((a, b) => a + b, 0);
                  let percentage = ((value / total) * 100).toFixed(2);
                  return `${percentage}%`;
                },
              },
              outlabels: {
                stretch: 15,
                lineColor: "#212121",
              },
            },
          }}
          data={this.state.chartData}
        />
      </div>
    );
  };

  handleRadioChanged = (e) => {
    this.setState(
      {
        toView: e,
        clusterId: null,
        areaId: null,
        areaSelectContext: null,
        clusterSelectContext: null,
      },
      () => {
        this.refresh();
      }
    );
  };

  renderOptions = () => {
    var { package_list } = this.props;

    return (
      <Toolbar className="float-right">
        <ToggleButtonGroup
          hidden={package_list.length === 0}
          onChange={this.handleRadioChanged}
          size="sm"
          name="filterByRadio"
          type="radio"
          value={this.state.toView}
        >
          <ToggleButton size="sm" variant="light" value="piece">
            Piece
          </ToggleButton>
          <ToggleButton size="sm" variant="light" value="principal">
            Principal
          </ToggleButton>
        </ToggleButtonGroup>
        <IconButton
          onClick={() => {
            this.props.openModal({
              custom: false,
              size: "lg",
              title: "Packages",
              currentComponent: <PackageViewFilter Refresh={this.refresh} />,
            });
          }}
        >
          <Search />
        </IconButton>

        <IconButton
          hidden={package_list.length === 0}
          onClick={() => {
            this.props.openModal({
              custom: true,
              size: "lg",
              title: "Packages",
              currentComponent: (
                <>
                  <strong>{this.props.chartTitle}</strong>
                  <Bar
                    options={{
                      title: {
                        display: false,
                        text: this.props.chartTitle,
                        fontsize: 20,
                      },
                      layout: {
                        padding: {
                          left: 60,
                          right: 60,
                          top: 40,
                          bottom: 20,
                        },
                      },
                      legend: {
                        display: false,
                        position: "left",
                      },
                      plugins: {
                        tooltip: {
                          callbacks: {
                            label: function (tooltipItem) {
                              let dataset = tooltipItem.dataset;
                              let currentValue =
                                dataset.data[tooltipItem.dataIndex];
                              let total = dataset.data.reduce(
                                (a, b) => a + b,
                                0
                              );
                              let percentage = (
                                (currentValue / total) *
                                100
                              ).toFixed(2);
                              return ` ${percentage}%`;
                            },
                          },
                        },
                        datalabels: {
                          display: true,
                          color: "#212121",
                          formatter: function (value, context) {
                            let dataset = context.dataset.data;
                            let total = dataset.reduce((a, b) => a + b, 0);
                            let percentage = ((value / total) * 100).toFixed(2);
                            return `${percentage}%`;
                          },
                        },
                        outlabels: {
                          stretch: 14,
                          lineColor: "#212121",
                        },
                      },
                    }}
                    data={this.state.chartData}
                  />
                </>
              ),
            });
          }}
        >
          <AspectRatio />
        </IconButton>
      </Toolbar>
    );
  };

  render() {
    var { package_list } = this.props;
    return this.state.isLoading ? (
      <PieChartLoader />
    ) : (
      <div>
        {package_list.length === 0 ? (
          <NoChartData />
        ) : (
          <div>
            <strong>{this.props.chartTitle}</strong>
            {this.renderPie()}
          </div>
        )}
        {this.renderOptions()}
      </div>
    );
  }

  premiseGetPackageOverallV4 = (dates) => {
    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.overall,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY")
    );

    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageOverallV4(dates);
  };
}

const mapStateToProps = (state) => {
  return {
    chartTitle: state.chart_title.packages,

    package_list: state.package.package_list,
  };
};

const mapDispatchToProps = {
  openModal: openModal,
  SetChartPackagesTitle: SetChartPackagesTitle,
  GetPackageOverallV4: GetPackageOverallV4,
  GetPackageClusterV4: GetPackageClusterV4,
  GetPackageAreaV4: GetPackageAreaV4,
};

PackageView.contextType = DashboardContext;

export default connect(mapStateToProps, mapDispatchToProps)(PackageView);
